import { get, post } from './api';

// Create or update settings

export const createSetting = (data) => {
  return post("/settings", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Get all settings
export const getAllSettings = (group) => {
  return get(`/settings?group=${group}`);
};




